import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from '../../apiService/allApi';
import "../css/base.css"; // Ensure you create this CSS file
import { RiShieldUserLine } from "react-icons/ri";
import { BsFacebook } from "react-icons/bs";
import OtpInput from "react-otp-input";
import "../css/LoginNew.css"


export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { referralcode } = useParams();

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [isValid, setIsValid] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [showSplash, setShowSplash] = useState(true);
  const referral = referralcode || location.pathname.split("/")[2] || "";


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      clearInterval(timerInterval);
      setIsValid(false);
    }
    return () => clearInterval(timerInterval);
  }, [isValid, seconds]);

  const handleClick = async (e) => {
    if (e) e.preventDefault();
    if (!Phone || Phone.length !== 10) {
      return Swal.fire({ icon: "error", title: "Oops...", text: "Please enter correct phone number" });
    }
    setIsloading1(true);
    const respone = await apiRequest('login', "POST", { Phone, referral });
    setIsloading1(false);
    if (respone?.data?.status === 200) {
      setOtp(true);
      setIsValid(true);
      setSeconds(60);
      setSecretCode(respone?.data?.secret);
      if (respone?.data?.myToken) {
        Swal.fire({ icon: "success", title: "OTP", text: "Demo OTP: " + respone?.data?.myToken });
      }
    } else {
      Swal.fire({ icon: "error", title: "Oops...", text: respone?.data?.msg || "Login failed" });
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode });
      setIsloading1(false);
      if (response?.data?.status === 200) {
        localStorage.setItem("token", response?.data?.token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({ icon: "error", title: "Oops...", text: response?.data?.msg || "Something went wrong!" });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({ icon: "error", title: "Oops...", text: "Error verifying OTP" });
    }
  };
  if (showSplash) {
    return (
      <>
        {/* ==================== BOX LUDO SPLASH SCREEN ==================== */}
        <div className="bl-splash-screen">

          {/* BACKGROUND IMAGE */}
          <div className="bl-splash-background" />

          {/* DARK OVERLAY */}
          <div className="bl-splash-overlay" />

          {/* AMBIENT LIGHTS */}
          <div className="bl-splash-orb bl-splash-orb-one" />
          <div className="bl-splash-orb bl-splash-orb-two" />
          <div className="bl-splash-orb bl-splash-orb-three" />

          {/* FLOATING DICE */}
          <div className="bl-splash-floating-dice bl-dice-one">
            🎲
          </div>

          <div className="bl-splash-floating-dice bl-dice-two">
            🎲
          </div>

          <div className="bl-splash-floating-dice bl-dice-three">
            🎲
          </div>

          {/* FLOATING GAME TOKENS */}
          {/* <div className="bl-splash-token bl-token-red">
            <span />
          </div>

          <div className="bl-splash-token bl-token-blue">
            <span />
          </div>

          <div className="bl-splash-token bl-token-green">
            <span />
          </div>

          <div className="bl-splash-token bl-token-yellow">
            <span />
          </div> */}

          {/* MAIN CONTENT */}
          <main className="bl-splash-content">

            {/* ANIMATED LOGO */}
            <div className="bl-splash-logo-section">

              <div className="bl-logo-glow" />

              <div className="bl-logo-orbit bl-logo-orbit-one" />
              <div className="bl-logo-orbit bl-logo-orbit-two" />

              <div className="bl-logo-spark bl-logo-spark-one">✦</div>
              <div className="bl-logo-spark bl-logo-spark-two">✧</div>
              <div className="bl-logo-spark bl-logo-spark-three">✦</div>

              <img
                src="./images/box-ludo-logo.png"
                alt="BOX LUDO"
                className="bl-splash-logo"
              />
            </div>

            {/* BRAND HEADING */}
            <div className="bl-splash-brand">

              <h1 className="bl-brand-title">
                <span className="bl-brand-box">BOX</span>
                <span className="bl-brand-ludo"> LUDO</span>
              </h1>

              <div className="bl-brand-underline">
                <span />
                <i>✦</i>
                <span />
              </div>

            </div>

            {/* TAGLINE */}
            <div className="bl-splash-tagline-wrap">

              <h2 className="bl-splash-tagline">
                Roll the Dice.
              </h2>

              <h2 className="bl-splash-tagline bl-splash-tagline-highlight">
                Rule the Board!
              </h2>

            </div>

            {/* DECORATIVE DIVIDER */}
            <div className="bl-splash-divider">
              <span />
              <i>◆</i>
              <span />
            </div>

            {/* ANIMATED GAME MESSAGE */}

            {/* FOOTER */}
            <div className="bl-splash-footer">

              <span className="bl-footer-line" />

              <p>YOUR GAME. YOUR GLORY.</p>

              <span className="bl-footer-line" />

            </div>

          </main>

        </div>
      </>
    );
  }
  return (
    <>



      {/* ==================== BOX LUDO LOGIN PAGE ==================== */}
      <div className="bl-login-screen">
        {/* Background */}
        <div className="bl-login-bg-image" />
        <div className="bl-login-bg-overlay" />

        {/* Animated background elements */}
        <div className="bl-login-glow bl-glow-one" />
        <div className="bl-login-glow bl-glow-two" />

        <div className="bl-floating-dice bl-dice-one">⚄</div>
        <div className="bl-floating-dice bl-dice-two">⚅</div>

        <div className="bl-floating-token bl-token-red">
          <span />
        </div>

        <div className="bl-floating-token bl-token-blue">
          <span />
        </div>

        {/* Main content */}
        <main className="bl-login-main">
          {/* Compact branding */}
          <header className="bl-brand-section">
            <div className="bl-brand-logo-wrap">
              <div className="bl-brand-logo-glow" />

              <img
                src="./images/box-ludo-logo.png"
                alt="BOX LUDO"
                className="bl-brand-logo"
              />
            </div>

            <div className="mt-4">
              <img
                src="./images/login-dec.png"
                alt="BOX LUDO"
                className="img-fluid"
              />
            </div>

            <div className="bl-brand-divider">
              <span />
              <i>♛</i>
              <span />
            </div>
          </header>

          {/* Login card */}
          <section className="bl-login-card">
            <div className="bl-card-top-glow" />

            <div className="bl-login-card-header">
              <div className="bl-login-card-icon">
                <RiShieldUserLine />
              </div>

              <div className="bl-login-card-heading">
                <span className="bl-card-eyebrow">
                  WELCOME TO BOX LUDO
                </span>

                <h2>Register / Login</h2>

                <p>Enter your mobile number to continue</p>
              </div>
            </div>


            {/* Login form */}
            <form
              className="bl-login-form"
              onSubmit={otp ? varifyOtp : handleClick}
            >
              <label
                className="bl-field-label"
                htmlFor="blMobileNumber"
              >
                Mobile Number
              </label>

              <div className="bl-mobile-input-wrap">
                <div className="bl-mobile-prefix">
                  <img
                    src="https://flagcdn.com/w40/in.png"
                    alt="India"
                    className="bl-mobile-flag"
                  />

                  <span>+91</span>
                </div>

                <span className="bl-mobile-input-divider" />

                <input
                  id="blMobileNumber"
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel-national"
                  placeholder="Enter mobile number"
                  value={Phone}
                  disabled={otp}
                  maxLength={10}
                  onChange={(e) =>
                    setPhone(
                      e.target.value.replace(/\D/g, "").slice(0, 10)
                    )
                  }
                  required
                />

                {Phone.length === 10 && (
                  <span className="bl-mobile-valid">✓</span>
                )}
              </div>

              <p className="bl-input-helper">
                We will send an OTP to verify your mobile number.
              </p>

              {/* Continue button */}
              <button
                type="submit"
                className="bl-continue-btn"
                disabled={isLoading1 || Boolean(otp)}
              >
                {isLoading1 ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    <span>Processing...</span>
                  </>
                ) : (
                  <>
                    <span>CONTINUE</span>
                    <span className="bl-continue-arrow">→</span>
                  </>
                )}
              </button>


            </form>

            {/* Footer */}
            <div className="bl-login-card-footer">
              <RiShieldUserLine />

              <p>
                By logging in, you agree to our{" "}
                <span>Terms &amp; Conditions</span>
              </p>
            </div>
          </section>

          <div className="bl-login-bottom-caption">
            <span>✦</span>
            MADE FOR THE LOVE OF LUDO
            <span>✦</span>
          </div>
        </main>

        {/* OTP popup */}
        {otp && (
          <div className="bl-otp-overlay">
            <div className="bl-otp-backdrop-glow" />

            <div
              className="bl-otp-popup"
              role="dialog"
              aria-modal="true"
              aria-labelledby="blOtpTitle"
            >
              <button
                type="button"
                className="bl-otp-close"
                onClick={() => setOtp(false)}
                aria-label="Close OTP verification"
              >
                ×
              </button>

              <div className="bl-otp-icon">
                <RiShieldUserLine />
                <span className="bl-otp-icon-check">✓</span>
              </div>

              <span className="bl-otp-eyebrow">
                ONE MORE STEP
              </span>

              <h3 id="blOtpTitle">Verify Your Number</h3>

              <p className="bl-otp-description">
                Enter the 6-digit verification code sent to
                <br />
                <strong>+91 {Phone}</strong>
                <span className="bl-otp-verified-check"> ✓</span>
              </p>

              <label className="bl-otp-label">
                ENTER VERIFICATION CODE
              </label>

              <div className="bl-otp-inputs">
                <OtpInput
                  value={twofactor_code}
                  onChange={(value) =>
                    settwofactor_code(value.replace(/\D/g, ""))
                  }
                  numInputs={6}
                  shouldAutoFocus
                  containerStyle="bl-otp-input-container"
                  renderInput={(props) => (
                    <input
                      {...props}
                      className="bl-otp-digit"
                      type="text"
                      inputMode="numeric"
                      autoComplete="one-time-code"
                    />
                  )}
                />
              </div>

              <div className="bl-otp-resend">
                {seconds > 0 ? (
                  <span>
                    Resend code in <strong>{seconds}s</strong>
                  </span>
                ) : (
                  <button
                    type="button"
                    className="bl-otp-resend-btn"
                    onClick={handleClick}
                  >
                    Resend OTP
                  </button>
                )}
              </div>

              <button
                type="button"
                className="bl-otp-verify-btn"
                onClick={varifyOtp}
                disabled={isLoading1 || twofactor_code.length !== 6}
              >
                {isLoading1 ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    <span>Verifying...</span>
                  </>
                ) : (
                  <>
                    <span>VERIFY &amp; LOGIN</span>
                    <span className="bl-btn-arrow">→</span>
                  </>
                )}
              </button>

              <div className="bl-otp-secure-note">
                <RiShieldUserLine />
                Your verification is secure.
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}